import styled from 'styled-components'
import { pxToRem } from '../../utils'

const InputError = styled.span`
  color: red;
  font-size: ${pxToRem(12)};
`

export default InputError



// WEBPACK FOOTER //
// ./src/components/Form/InputError.js